export default function orderNavigation<T extends { id: number }>(items: T[], savedIds: unknown): T[] {
  if (!Array.isArray(savedIds) || savedIds.length === 0) {
    return items;
  }

  const rank = new Map<number, number>();
  savedIds.forEach((id, index) => {
    if (typeof id === 'number' && !rank.has(id)) {
      rank.set(id, index);
    }
  });

  let anchor = -1;

  return items
    .map((item, position) => {
      const saved = rank.get(item.id);
      if (saved !== undefined) {
        anchor = saved;
        return { item, major: saved, minor: 0, position };
      }
      return { item, major: anchor, minor: 1, position };
    })
    .sort((a, b) => a.major - b.major || a.minor - b.minor || a.position - b.position)
    .map((entry) => entry.item);
}
